import React from 'react';
import './promo.scss';
import PropTypes from 'prop-types';
import Icon from '../../components/mweb/Icon/Icon';
import Button from '../../components/common/Button/Button';

const PromoCard = ({ promo, ctaText = 'Apply', onCtaClick }) => {
  return (
    <div className="promo-card">
      <div className="promo-card--icon flex-shrink-0">
        <div className="promo-card--icon-bg">
          <Icon class="icon-cart-promo-sample" size={30} />
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="justify-content--space-between">
          <div className="promo-card--code">{promo.promoCode}</div>
          <Button
            className="button action-link promo-card--apply-cta"
            onClick={() => onCtaClick(promo.promoCode)}
          >
            {ctaText}
          </Button>
        </div>
        <div className="promo-card--description">
          <span>{promo.description}</span>
          {promo.suggestion && (
            <div className="promo-card--suggestion">{promo.suggestion}</div>
          )}
        </div>
      </div>
    </div>
  );
};

PromoCard.propTypes = {
  promo: PropTypes.object.isRequired,
  ctaText: PropTypes.string,
  onCtaClick: PropTypes.func.isRequired,
};

export default PromoCard;
